var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-button",
    {
      staticClass: "md-primary md-just-icon md-round",
      attrs: { title: "Edit Issue" },
      on: { click: _vm.showUpdateIssueDialog },
    },
    [_c("md-icon", [_vm._v("edit")])],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }